<section id="content">
	<form id="form" class="form">

		<div class="spinner-container">
			<div class="spinner">
				<div class="sk-folding-cube">
					<div class="sk-cube1 sk-cube"></div>
					<div class="sk-cube2 sk-cube"></div>
					<div class="sk-cube4 sk-cube"></div>
					<div class="sk-cube3 sk-cube"></div>
				</div>
			</div>
		</div>

		<div class="row">

			<div id="chart-table" class="col-md-6 col-sm-12 col-xs-12 table-cont1">

				<div class="to5-active" id="to5-active" *ngIf="topFiveActivePerm">
					<div class="card" style="height: 600px;">
						<div class="card-title">
							<h2 id="TopTitle">Top {{topFiveActive?.length}} Active Opportunities</h2>
						</div>
						<div class="cont" id="chart-Contanier-1">
							<!-- <canvas height="557px" id="chart-1"> -->
							<p-chart height="500px" #chart type="bar" [data]="topFiveActiveChart"
								[options]="chartOptions" (onDataSelect)="selectData($event)"></p-chart>
							<!-- </canvas> -->
						</div>
					</div>
				</div>

				<div class="card">
					<div class="card-title">
						<h2>Pipline By Opportunity Status</h2>
					</div>
					<div class="cont" id="chart-Contanier-2">
						<p-chart height="300px" #pieChart type="pie" [data]="pipelineChart"
							[options]="pieChartOptions"></p-chart>
					</div>
				</div>

				<div class="card" hidden>
					<div class="card-title">
						<h2 class="Quota">Quota Achievement:0% </h2>
					</div>
					<div class="cont">
						<!--<canvas id="chart-2" height="339px"></canvas>
						-->
						<p-chart type="pie" [data]="quotaAchievementChart" [options]="pieChartOptions"></p-chart>
					</div>
				</div>

				<div class="card" hidden>
					<div class="card-title">
						<h2>Sales Revenues VS Quota Trend</h2>
					</div>
					<div class="cont">
						<!--<canvas id="chart-5" height="339px"></canvas>-->
						<p-chart type="line" [data]="revenueVsTrendChart"></p-chart>
					</div>
				</div>
			</div>

			<div class="col-md-3 col-sm-12 col-xs-12 table-cont2">



				<div id="sss-summery">
					<div class="card" id="breifCard" *ngIf="opportunitiesBriefPerm">
						<div class="card-title">
							<h2>Brief</h2>
						</div>
						<div class="cont">
							<ul class="list" id="Brief" style="margin-top: -15px;">
								<li><a>
										<h3>Closed Revenue</h3>
										<p>{{opportunitiesBrief?.closedRevenue | number}} USD</p>
									</a></li>
								<li><a>
										<h3>Quota Achievement</h3>
										<p>{{opportunitiesBrief?.quotaAchievement}} %</p>
									</a></li>
								<li><a>
										<h3>Opportunities</h3>
										<p>{{opportunitiesBrief?.value | number}} USD</p>
									</a></li>
								<li><a>
										<h3>Wieght Of Opportunities</h3>
										<p>{{opportunitiesBrief?.weight | number}} USD</p>
									</a></li>
							</ul>
						</div>
					</div>

					<div class="card hidden" id="summaryCard" *ngIf="summaryCardPerm">
						<div class="card-title clearfix">
							<h2 class="pull-left">Total Summary</h2>

						</div>
						<div class="cont">
							<table class="table borderless" id="sss_sum">
								<tr>
									<th>No. of Opps</th>
									<td id="noOpp">
										<p>{{sssSummary?.total?.counter}}</p>
									</td>
								</tr>
								<tr>
									<th>Value of Opps</th>
									<td id="valOpp">
										<p>{{sssSummary?.total?.value | number}} USD</p>
									</td>
								</tr>
								<tr>
									<th>Weight of Opps</th>
									<td id="wOpp">
										<p>{{sssSummary?.total?.weight | number}} USD</p>
									</td>
								</tr>
							</table>
						</div>
					</div>

					<div class="card hidden" id="swgLicSummaryCard" *ngIf="swgLicSummaryCardPerm">
						<div class="card-title clearfix">
							<h2 class="pull-left">SWG License Summary</h2>

						</div>
						<div class="cont">
							<table class="table borderless" id="">
								<tr>
									<th>No. of Opps</th>
									<td id="swgLicNoOpp">
										<p>{{sssSummary?.licenseSwg?.counter}}</p>
									</td>
								</tr>
								<tr>
									<th>Value of Opps</th>
									<td id="swgLicValOpp">
										<p>{{sssSummary?.licenseSwg?.value | number}} USD</p>
									</td>
								</tr>
								<tr>
									<th>Weight of Opps</th>
									<td id="swgLicWOpp">
										<p>{{sssSummary?.licenseSwg?.weight | number}} USD</p>
									</td>
								</tr>
							</table>
						</div>
					</div>

					<div class="card hidden" id="swgSerSummaryCard" *ngIf="swgSerSummaryCardPerm">
						<div class="card-title clearfix">
							<h2 class="pull-left">SWG Services Summary</h2>

						</div>
						<div class="cont">
							<table class="table borderless" id="">
								<tr>
									<th>No. of Opps</th>
									<td id="swgSerNoOpp">
										<p>{{sssSummary?.serviceSwg?.counter}}</p>
									</td>
								</tr>
								<tr>
									<th>Value of Opps</th>
									<td id="swgSerValOpp">
										<p>{{sssSummary?.serviceSwg?.value | number}} USD</p>
									</td>
								</tr>
								<tr>
									<th>Weight of Opps</th>
									<td id="swgSerWOpp">
										<p>{{sssSummary?.serviceSwg?.weight | number}} USD</p>
									</td>
								</tr>
							</table>
						</div>
					</div>


					<div class="card hidden" id="stgHWSummaryCard" *ngIf="stgHWSummaryCardPerm">
						<div class="card-title clearfix">
							<h2 class="pull-left">STG Hardware Summary</h2>

						</div>
						<div class="cont">
							<table class="table borderless" id="">
								<tr>
									<th>No. of Opps</th>
									<td id="stgHWNoOpp">
										<p>{{sssSummary?.hardwareStg?.counter}}</p>
									</td>
								</tr>
								<tr>
									<th>Value of Opps</th>
									<td id="stgHWValOpp">
										<p>{{sssSummary?.hardwareStg?.value | number}} USD</p>
									</td>
								</tr>
								<tr>
									<th>Weight of Opps</th>
									<td id="stgHWWOpp">
										<p>{{sssSummary?.hardwareStg?.weight | number}} USD</p>
									</td>
								</tr>
							</table>
						</div>
					</div>

					<div class="card hidden" id="stgSerSummaryCard" *ngIf="stgSerSummaryCardPerm">
						<div class="card-title clearfix">
							<h2 class="pull-left">STG Services Summary</h2>

						</div>
						<div class="cont">
							<table class="table borderless" id="">
								<tr>
									<th>No. of Opps</th>
									<td id="stgSerNoOpp">
										<p>{{sssSummary?.serviceStg?.counter}}</p>
									</td>
								</tr>
								<tr>
									<th>Value of Opps</th>
									<td id="stgSerValOpp">
										<p>{{sssSummary?.serviceStg?.value | number}} USD</p>
									</td>
								</tr>
								<tr>
									<th>Weight of Opps</th>
									<td id="stgSerWOpp">
										<p>{{sssSummary?.serviceStg?.weight | number}} USD</p>
									</td>
								</tr>
							</table>
						</div>
					</div>
				</div>
			</div>
			<app-filter [displayProductKindCheckBoxes]="displayProductKindCheckBoxes" [filterForPage]="filterForPage"
				[sectors]="sectors" [regionsList]="regionsList" [statusList]="statusList" [salesUsers]="salesUsers"
				(onResetClick)="onResetClick($event)" (onDropDownClicked)="onDropDownClicked($event)"
				(onCheckBoxClicked)="onCheckBoxClicked($event)" (filterClicked)="filterClicked($event)"></app-filter>
		</div>

		<div class="row">
			<div class="col-md-9 col-sm-12 col-xs-12 table-cont3">

				<div class="card hidden" id="sectorSummaryCard" *ngIf="sectorsSummaryPerm">
					<div class="card-title clearfix">
						<h2 class="pull-left">Sectors Pipline Summary</h2>

					</div>
					<div class="cont">
						<table class="table table-bordered" id="sss_sec_sum">
							<thead>
								<tr>
									<th>Sector</th>
									<th *ngFor="let summary of sectorPipelineSummary">
										{{summary?.name}}
									</th>
								</tr>
							</thead>
							<tbody>
								<!-- Iterate SectorBrandData and display the table  -->
								<tr>
									<td>Pipeline Value</td>
									<td *ngFor="let summary of sectorPipelineSummary">
										{{summary?.pipelineValue | number}}
									</td>
								</tr>
								<tr>
									<td>Weighted Pipeline Value</td>
									<td *ngFor="let summary of sectorPipelineSummary">
										{{summary?.weightedValue | number}}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div class="card hidden" id="brandSummaryCard" *ngIf="brandsSummaryPerm">
					<div class="card-title clearfix">
						<h2 class="pull-left">Brands Pipline Summary</h2>

					</div>
					<div class="cont">
						<table class="table table-bordered" id="sss_brand_sum">
							<thead>
								<tr>
									<th style="width: 33%;">Brand</th>
									<th style="width: 33%;">Pipeline Value</th>
									<th style="width: 33%;">Weighted Pipeline Value</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let summary of brandsPipelineSummary">
									<td>
										{{summary?.name}}
									</td>
									<td>
										{{summary?.pipelineValue | number}}
									</td>
									<td>
										{{summary?.weightedValue | number}}
									</td>
								</tr>
							</tbody>
						</table>
					</div>



				</div>

				 <div class="card" id="technicalManagerSummaryCard" *ngIf="hasTechLeadAccess || isDeliveryManager()">
					<div class="card-title clearfix">
						<h2 class="pull-left">Technical Manager Opportunities</h2>
					</div>
					<div class="cont">
						<div class="table-responsive">
							<table class="table table-bordered">
								<thead>
									<tr>
										<th>Technical Manager</th>
										<th>Opportunities Count</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let item of technicalManagerData">
										<td>{{ item.techLeadName }}</td>
										<td>{{ item.opportunitiesCount }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div> 
				<div class="card" *ngIf=" hasTechLeadAccess || isDeliveryManager()" >
					<div class="card-title clearfix">
						<h2 class="pull-left">Technical Manager Opportunities</h2>
					</div>
					<div class="cont">
						<p-chart type="bar" [data]="chartData2" [options]="technicalManagerOpportinitiesOptions"></p-chart>
					</div>
				</div>

				<div class="card" *ngIf="hasTechLeadAccess">
					<div class="card-title clearfix">
						<div class="card-title clearfix">
							<h2 class="pull-left">Opportunities List </h2>
						</div>
						<form>
							<br>
							<div class="dropdown-container">
								<label style="display: inline-block; margin-bottom: 0.5rem;">Technical Lead:</label>
								<p-dropdown [options]="techLeads" optionLabel="firstName" optionValue="userId"
									filter="true" name="techLead" required [(ngModel)]="selectedTechLead"
									(onChange)="onTechLeadChange($event)" id="techLead" placeholder="Select..."
									[optionLabel]="getTechLeadLabel">
									
									
									<ng-template let-option pTemplate="selectedItem">
										<div class="item">
											<div>{{option.firstName + " " + option.lastName}}</div>
										</div>
									</ng-template>
									<ng-template let-option pTemplate="item">
										<span
											id="{{option.firstName + ' ' + option.lastName}}">{{option.firstName
											+ " " + option.lastName}}</span>
									</ng-template> 


								</p-dropdown>

			
							</div>
							<!-- comment-->
							<!-- <div *ngIf="opportunities.length > 0" class="table-container">
								<table class="table table-bordered">
									<thead>
										<tr>
											<th>Opportunity Name</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let opportunity of opportunities">
											<td>{{ opportunity }}</td>
										</tr>
									</tbody>
								</table>
							</div> -->


							<div class="table-responsive">
								<p-table *ngIf="selectedTechLead || isDeliveryManager()" #dt class="table ui-table-customers"
									[value]="filteredOpportunities" [totalRecords]="filteredOpportunities.length"
									rowHover="true">

									<ng-template pTemplate="header">
										<tr>
											<th pSortableColumn="opportunity" width="990px">Opportunity</th>
										</tr>
										<tr>
											<th>
												<input pInputText class="textfilter" type="text"
													(input)="onSearch($event)" placeholder="Search">
											</th>
										</tr>
									</ng-template>

									<ng-template pTemplate="body" let-opportunity>
										<tr>
											<td class="centered-frame">{{opportunity}}</td>
										</tr>
									</ng-template>
								</p-table>
							</div>

						</form>
						
					</div>
				</div>

				
	
			</div>
		</div>


	</form>
</section>